import { generateVuexCrud, singleEntityRequest } from '@/utilities/crud/vuex';

const crud = generateVuexCrud({
    single: 'refreshOperation',
    eventNamespace: 'Vendors.Refresh',
});

const state = {
    ...crud.state,
};

const actions = {
    ...crud.actions,

    cancelRefreshOperation(store, { refreshOperation }) {
        return singleEntityRequest('refreshOperation', {
            method: 'post',
            url: `/api/refreshoperations/${refreshOperation.id}/cancel`,
        });
    },

    subscribe({ dispatch }, { channels }) {
        if (channels.indexOf('refreshOperations') === -1) {
            return;
        }

        return dispatch('subscribeRefreshOperations');
    },
    unsubscribe({ dispatch }, { channels }) {
        if (channels.indexOf('refreshOperations') === -1) {
            return;
        }

        return dispatch('unsubscribeRefreshOperations');
    },
};

const mutations = {
    ...crud.mutations,
};

export default {
    state,
    actions,
    mutations,
};
